import { render, staticRenderFns } from "./PageAppbar.vue?vue&type=template&id=32e4e2e4&scoped=true"
import script from "./PageAppbar.vue?vue&type=script&lang=js"
export * from "./PageAppbar.vue?vue&type=script&lang=js"
import style0 from "./PageAppbar.vue?vue&type=style&index=0&id=32e4e2e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e4e2e4",
  null
  
)

export default component.exports